import React from 'react';

import { Headline } from './Headline';
import { THeroCardProps } from './HeroCard';
import { HeroCards } from './HeroCards';
import { OneWayBanner } from './OneWayBanner';
import { StickySearchWidget } from './StickySearchWidget';
import { Trips } from './Trips';

type THeroProps = {
  headline: Array<string | string[]>;
  cards: THeroCardProps[];
  locale: string;
  myIPAddress?: string;
};

export const Hero = (props: THeroProps) => {
  return (
    <div className="px-6 pt-2 mx-auto max-w-xxxxl lg:px-20">
      <Headline value={props.headline} />
      <StickySearchWidget />
      <OneWayBanner />
      <Trips locale={props.locale} />
      <HeroCards cards={props.cards} myIPAddress={props.myIPAddress} />
    </div>
  );
};
